<template>
  <div class="main">
    <a-row>
      <a-col :span="14">
        <p class="main-index-account">
          <span>账户余额：</span>
          <span>￥{{userstatic.money}}</span>
        </p>
      </a-col>
    </a-row>

    <a-card title="" :bordered="false" class="main-index-tjinfo">
      <a-card-grid  :hoverable="false" >
        <router-link to="">
          <span>今日消费</span>
          <p>￥{{userstatic.todaycustom}}</p>
        </router-link>
      </a-card-grid>
      <a-card-grid  :hoverable="false" >
        <router-link to="">
          <span>近7日消费</span>
          <p>￥{{userstatic.nearcustom}}</p>
        </router-link>
      </a-card-grid>
      <a-card-grid  :hoverable="false" >
        <router-link to="">
          <span>今日流量</span>
          <p>{{userstatic.todayflow}}</p>
        </router-link>
      </a-card-grid>
      <a-card-grid  :hoverable="false" >
        <router-link to="">
          <span>近7日流量</span>
          <p>{{userstatic.nearflow}}</p>
        </router-link>
      </a-card-grid>
      <a-card-grid  :hoverable="false" >
        <router-link to="">
          <span>今日询盘量</span>
          <p>{{userstatic.todayvoice}}</p>
        </router-link>
      </a-card-grid>
    </a-card>

    <a-card title="近30天流量分析" :bordered="false" class="main-index-mcharts">
      <!-- <a-card-grid  :hoverable="false" > -->
        <a-row>
          <a-col :span="12">
            <div id="spin-content" style="width: 100%;height:400px;"></div>
          </a-col>
          <a-col :span="12">
            <div id="pie-content" style="width: 100%;height:400px;"></div>
          </a-col>
        </a-row>
      <!-- </a-card-grid> -->
    </a-card>

    <a-card  class="main-index-bcharts">
      <a-card-grid  :hoverable="false" >
        <div id="line-content" style="width: 100%;height:400px;"></div>
      </a-card-grid>
    </a-card>

    <a-row class="main-bottom-info" :gutter="16">
      <a-col :span="12" class="cgd">
        <a-card title="我的采购单" :hoverable="false">
          <a-button slot="extra" type="primary" @click="showModal">
            我要发布
          </a-button>
          <a-card-grid :hoverable="false">
            <router-link to="">
              <span>今日发布</span>
              <p>{{tj.todaycount}}条</p>
            </router-link>
          </a-card-grid >
          <a-card-grid :hoverable="false">
            <router-link to="">
              <span>近7日发布</span>
              <p>{{tj.nearcount}}条</p>
            </router-link>
          </a-card-grid>
          <a-card-grid :hoverable="false">
            <router-link to="">
              <span>累计发布</span>
              <p>{{tj.totalcount}}条</p>
            </router-link>
          </a-card-grid>
        </a-card>
      </a-col>


      <a-col :span="12">
        <a-card title="我的商机库" :hoverable="false" style="height:272px">
          <ul>
            <li @click="tipdeatil($event)" :id="pd.id" v-for="pd in sjlist" :key="pd.id">
              <a-row type="flex" justify="center">
                <a-col :span="16">
                  <a-tag color="green">
                    {{pd.isower}}
                  </a-tag>
                  <span   class="content">{{pd.remark}}</span>
                </a-col>
                <a-col :span="8"  class="date">
                  <span>{{pd.create_time}}</span>
                </a-col>
              </a-row>
            </li>
          </ul>
        </a-card>
      </a-col>
    </a-row>

    <!-- 我要发布 -->
    <a-modal v-model="visible" width="1000px" :centered="true" cancelText="取消"
        okText="确定"  title="我要发布采购需求" @ok="handleOk">
      <!-- <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
          确定
        </a-button>
      </template> -->
      <a-descriptions class="release-modal fb" title="商品信息" bordered>

        <a-descriptions-item class="required-icon" label="商品名称：" :span="3">
          <a-input v-model="form.name" />
        </a-descriptions-item>

        <a-descriptions-item label="数量：" :span="1">
          <a-input v-model="form.num" />
        </a-descriptions-item>

        <a-descriptions-item label="单位：" :span="2">
          <a-input v-model="form.unit" />
        </a-descriptions-item>

        <a-descriptions-item label="品牌：">
          <a-input v-model="form.brand" />
        </a-descriptions-item>

        <a-descriptions-item label="报名截至日期：" :span="2">
          <a-date-picker  @change="onChange" placeholder="请选择日期" :disabledDate="disabledDate"/>
        </a-descriptions-item>

        <a-descriptions-item label="图片：" :span="3">
          <!-- <a-upload
            name="avatar"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            action=""
            :before-upload="beforeUpload"
            @change="handleChange"
          >
            <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">
                上传图片
              </div>
            </div>
          </a-upload> -->

           <a-upload
              action="/api/upload"
              list-type="picture-card"
              :file-list="fileList"
              @preview="handlePreview"
              @change="handleChange"
            >
              <div v-if="fileList.length < 8">
                <a-icon type="plus" />
                <div class="ant-upload-text">
                  上传图片
                </div>
              </div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancelimg">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>

        </a-descriptions-item>

        <a-descriptions-item label="备注：" :span="3">
          <a-textarea placeholder="" :rows="4" v-model="form.remark"/>
        </a-descriptions-item>

      </a-descriptions>

      <a-descriptions class="release-modal contact" title="联系方式" bordered style="margin-top:20px">
        <a-descriptions-item label="联系人：" :span="1">
          <a-input v-model="form.contract" />
        </a-descriptions-item>
        <a-descriptions-item label="手机号：" :span="2">
          <a-input v-model="form.phone" />
        </a-descriptions-item>
        <a-descriptions-item label="收货地址：" :span="1">
          <!-- <a-cascader style="width:100%" :options="options" placeholder="请选择城市" @change="changeCity" /> -->
          <a-input v-model="form.address"></a-input>
        </a-descriptions-item>
        <a-descriptions-item label="公司名称：" :span="2">
          <a-input v-model="form.company" :disabled="true"/>
        </a-descriptions-item>
      </a-descriptions>

    </a-modal>

    <!-- 留言详情 -->
    <a-modal v-model="tipvisible" width="700px" :centered="true"  title="留言详情"  class="tipdeatil">
       <a-row>
              <a-col :span="12">
              <a-row>
                  <a-col :span="6">
                  <label>公司名：</label>
                  </a-col>
                  <a-col :span="18">
                  <a-input :value="form.company" :disabled='true'/>
                  </a-col>
              </a-row>
              </a-col>
              <a-col :span="12">
              <a-row>
                  <a-col :span="6">
                  <label>留言时间：</label>
                  </a-col>
                  <a-col :span="18">
                  <a-input :value="form.create_time" :disabled='true'/>
                  </a-col>
              </a-row>
              </a-col>
          </a-row>

          <a-row>
            <a-col :span="12">
            <a-row>
                <a-col :span="6">
                <label>客户名：</label>
                </a-col>
                <a-col :span="18">
                <a-input :value="form.name" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
            <a-col :span="12">
            <a-row>
                <a-col :span="6">
                <label>联系电话：</label>
                </a-col>
                <a-col :span="18">
                <a-input :value="form.phone" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="12">
            <a-row>
                <a-col :span="6">
                <label>邮箱：</label>
                </a-col>
                <a-col :span="18">
                <a-input :value="form.email" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
            <a-col :span="12">
            <a-row>
                <a-col :span="6">
                <label>来源IP：</label>
                </a-col>
                <a-col :span="18">
                <a-input :value="form.ip" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
            <a-row>
                <a-col :span="6">
                <label>留言入口：</label>
                </a-col>
                <a-col :span="18">
                <a-input :value="form.place" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
            <a-col :span="12">
            <a-row>
                <a-col :span="6">
                <label>来源地区：</label>
                </a-col>
                <a-col :span="18">
                <a-input :value="form.area" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
            <a-row>
                <a-col :span="3">
                <label>页面路径：</label>
                </a-col>
                <a-col :span="21">
                <a-input :value="form.page" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="24">
            <a-row>
                <a-col :span="3">
                <label>留言内容：</label>
                </a-col>
                <a-col :span="21">
                <a-textarea :value="form.content" placeholder="" :rows="4" :disabled='true'/>
                </a-col>
            </a-row>
            </a-col>
          </a-row>

    </a-modal>

     

  </div>
</template>


<script>

let echarts = require('echarts/lib/echarts');
// 引入折线图/柱状图等组件
import Vue from 'vue';
import { FormModel } from 'ant-design-vue';
import moment from 'moment';
Vue.filter('comverTime',function(data,format){
  return moment(data).format(format);
});
Vue.use(FormModel);
require('echarts/lib/chart/bar')
require('echarts/lib/chart/pie')
require('echarts/lib/chart/line')
// 引入提示框和title组件，图例
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/legendScroll')//图例滚动
//vue全局注入echarts
Vue.prototype.$echarts = echarts

// function getimgurl(file) {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = error => reject(error);
//   });
// }

export default {
  data () {
    return {
      visible: false,
      tipvisible:false,
      form: {
        name: '',
        num: '',
        unit: '',
        brand: '',
        type: '',
        end_time: '',
        image: '',
        remark:'',
        contract:"",
        phone:"",
        company:"",
        address:''
      },
      loading: false,
      imageUrl: '',

      fileList:[],
      previewVisible: false,
      previewImage: '',

      options: [
        {
          value: 'zhejiang',
          label: 'Zhejiang',
          children: [
            {
              value: 'hangzhou',
              label: 'Hangzhou',
              children: [
                {
                  value: 'xihu',
                  label: 'West Lake',
                },
              ],
            },
          ],
        },
        {
          value: 'jiangsu',
          label: 'Jiangsu',
          children: [
            {
              value: 'nanjing',
              label: 'Nanjing',
              children: [
                {
                  value: 'zhonghuamen',
                  label: 'Zhong Hua Men',
                },
              ],
            },
          ],
        },
      ],

      sjlist:"",
      tj:"",
      userstatic:"",
      form:""

    }
  },
  mounted(){
     this.drawLine();

     this.$axios.get("/api/getpurchaselist",{
        headers: {
          "appid": this.appSet.appid,
          "appkey": this.appSet.appkey,
          "token":localStorage.getItem('token'),
        }
     }).then((res)=>{
       if(res.data.code==200){
         this.sjlist=res.data.data.lists
       }else if(res.data.code==300){
         this.$router.push({path: '/'})
       }
     })

    this.$axios.get("/api/getpurchasestatistic",{
        headers: {
          "appid": this.appSet.appid,
          "appkey": this.appSet.appkey,
          "token":localStorage.getItem('token'),
        }
     }).then((res)=>{
       if(res.data.code==200){
         this.tj=res.data.data
       }
     })

    this.$axios.get("/api/getuserstatistic",{
        headers: {
          "appid": this.appSet.appid,
          "appkey": this.appSet.appkey,
          "token":localStorage.getItem('token'),
        }
     }).then((res)=>{
       if(res.data.code==200){
         this.userstatic=res.data.data
       }else if(res.data.code==300){
         this.$router.push({path: '/'})
       }
     })
  },
  methods:{
    changeCity(value){
       console.log(value);
    },
    showModal() {
      this.visible = true;
    },

    
    tipdeatil(event){
        this.tipvisible=true
        var id=event.currentTarget.id
        this.$axios.get('/api/getvoicedetail',{
          headers: {
              "appid": this.appSet.appid,
              "appkey": this.appSet.appkey,
              "token":localStorage.getItem('token'),
          },
          params:{
            id:id
          }
      }).then((res)=>{
          if(res.data.code==200){
              this.form=res.data.data
          //     this.$axios.get('/api/getvoicelist',{
          //         headers: {
          //             "appid": this.appSet.appid,
          //             "appkey": this.appSet.appkey,
          //             "token":localStorage.getItem('token'),
          //         }
          //     }).then((res)=>{
          //         if(res.data.code==200){
          //             this.data=res.data.data.lists
          //         }
          //     })
          }
      })
    },

    handleOk(e) {

      var fileList=this.fileList
      for(var i in fileList){
        if(this.form.image==""){
          this.form.image=fileList[i].response.url
        }else if(fileList[i].response.url!=undefined){
          this.form.image=this.form.image+","+fileList[i].response.url
        }
      }
      // console.log("fileList="+this.form.image)
      var params=new URLSearchParams()
      params.append('name',this.form.name)
      params.append('num',this.form.num)
      params.append('unit',this.form.unit)
      params.append('brand',this.form.brand)
      params.append('end_time',this.form.end_time)
      params.append('image',this.form.image)
      params.append('remark',this.form.remark)
      params.append('contract',this.form.contract)
      params.append('company',this.form.company)
      params.append('address',this.form.address)
      this.$axios.post('/api/addpurchase',params,{
        headers: {
          "appid": this.appSet.appid,
          "appkey": this.appSet.appkey,
          "token":localStorage.getItem('token'),
        }
      }).then((res)=>{
        if(res.data.code==200){
          this.visible = false;
        }
      })

    },
    handleCancel(){
      this.visible = false;
    },

    // 日期
    onChange(date, dateString) {
      this.form.end_time=dateString;
    },
    disabledDate(current){
       return current && current < moment().endOf('day')
    },

    // 留言详情
    // tipdeatil(){
    //   this.tipvisible=true
    // },
    // 图片上传
    handleChangeimg(info) {
     this.previewVisible = false;
    },
    // async handlePreview(file) {
    //     if (!file.url && !file.preview) {
    //       file.preview = await getimgurl(file.originFileObj);
    //     }
    //     this.previewImage = file.url || file.preview;
    //     this.previewVisible = true;
    //   },
      handleChange({ fileList }) {
        this.fileList = fileList;
      },
       // 获取当前日期
      getDay(day) {　　
        var today = new Date();　　
        var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
        today.setTime(targetday_milliseconds); //注意，这行是关键代码
        　　
        var tYear = today.getFullYear();　　
        var tMonth = today.getMonth();　　
        var tDate = today.getDate();　　
        tMonth = this.doHandleMonth(tMonth + 1);　　
        tDate = this.doHandleMonth(tDate);　　
        return tYear + "-" + tMonth + "-" + tDate;
      },
      doHandleMonth(month) {　　
          var m = month;　　
          if (month.toString().length == 1) {　　
              m = "0" + month;　　
          }　　
          return m;
      },
    // 图表
    drawLine(){
      var spinContent = this.$echarts.init(document.getElementById("spin-content"))
      spinContent.setOption({
        title: {
          text: '搜索引擎分析',
          textStyle: {
            fontWeight: 'normal',
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {            
            type: 'shadow' 
          },
          backgroundColor:'#fff',	
          textStyle: {
            color: "#666" //设置文字颜色
          },

        },
        grid: {
            left: '0%',
            right: '8%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: [
            {   
              type: 'category',
              data: ['百度搜索', '手机百度', '360搜索', '手机360', '搜狗搜索', '手机搜狗', '其他'],
              axisTick: {
                  alignWithLabel: true
              }
            }
        ],
        yAxis: [
            {
                type: 'value'
            }
        ],
        series: [
          {
            name: '流量',
            type: 'bar',
            barWidth: '60%',
            data: [10, 52, 200, 334, 390, 330, 220],
            barWidth: 38,
            itemStyle: {
              normal: {
                //每根柱子颜色设置
                color: function (params) {
                  let colorList = ["#709af3", "#64ddae", "#f6b23f", "#ea6a65", "#7aceea",
                      "#a16dbc", "#749c51"
                  ];
                  return colorList[params.dataIndex];
                }
              }
            },
          }
        ]
      });

      var pieContent = this.$echarts.init(document.getElementById("pie-content"))
      pieContent.setOption({
        title: {
          text: '地区分析图',
          textStyle: {
            fontWeight: 'normal',
          }
        },
        tooltip: {
        trigger: 'item',
        formatter:function (params) {
          var color = params.color;//图例颜色
          var htmlStr ='<div>';
          htmlStr += params.name + '<br/>';//x轴的名称
          //为了保证和原来的效果一样，这里自己实现了一个点的效果
          htmlStr += '<span style="margin-right:12px;height:8px;width:8px;border-radius:50%;display:inline-block;background:'+color+'"></span>';
          
          //添加一个汉字，这里你可以格式你的数字或者自定义文本内容
          htmlStr += params.name + '：'+params.value;
          
          htmlStr += '</div>';
          
          return htmlStr;
          },
          backgroundColor:'#fff',	
          textStyle: {
            color: "#666",
          },

          extraCssText: 'box-shadow: 0 0 7px rgba(0, 0, 0, 0.5);'
        },
        legend: {
            icon: "circle", 
            itemWidth: 10, 
            itemHeight: 10,
            orient: 'vertical',
            right: 10,
            bottom:120,
            data: ['江苏', '上海', '浙江', '河北', '山东','北京','安徽']
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            avoidLabelOverlap: false,
            label: {
                show: false,
                position: 'center'
            },
            emphasis: {
                label: {
                    show: true,
                    fontSize: '30',
                    fontWeight: 'bold'
                }
            },
            labelLine: {
                show: false
            },
            data: [
              {value: 1548, name: '江苏'},
              {value: 1310, name: '上海'},
              {value: 234, name: '浙江'},
              {value: 135, name: '河北'},
              {value: 135, name: '山东'},
              {value: 248, name: '北京'},
              {value: 335, name: '安徽'}
            ],
              itemStyle: {
              normal: {
                //每根柱子颜色设置
                color: function (params) {
                  let colorList = ["#709af3", "#64ddae", "#f6b23f", "#ea6a65", "#7aceea",
                      "#a16dbc", "#749c51"
                  ];
                  return colorList[params.dataIndex];
                }
              }
            },
          }
        ]
      });

      var lineContent = this.$echarts.init(document.getElementById("line-content"))
          // 流量趋势
          var start_time=this.getDay(-7)
          var end_time=this.getDay(0)
      this.$axios.get("/api/flowtrend",{
        headers:{
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
        },
        params:{
          start_time:start_time,
          end_time:end_time
        }
      }).then((res)=> {
        if(res.data.code==200){
            this.flowtrendx=res.data.data.xstr
            this.flowtrendx= eval('(' +  this.flowtrendx + ')');
            this.flowtrendy=res.data.data.ystr
            this.flowtrendy= eval('(' +  this.flowtrendy + ')');

            lineContent.setOption({
              title: {
                text: '流量趋势图',
                textStyle: {
                  fontWeight: 'normal',
                }
              },
              color:'#709af3',
                tooltip: {
                trigger: 'axis',
                axisPointer: {            
                    type: 'line' 
                },
                backgroundColor:'#fff',	
                textStyle: {
                  color: "#666" //设置文字颜色
                },
                extraCssText: 'box-shadow: 0 0 7px rgba(0, 0, 0, 0.5);'
              },
              grid: {
                left: '2%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: this.flowtrendx
              },
              
              yAxis: {
                type: 'value'
              },
              series: [{
                name: '数量',
                data: this.flowtrendy,
                type: 'line',
                areaStyle: {
                  color:'#709af3',
                  opacity:0.4
                }
              }]
            });
          }
        })
    
    

    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/index/index.vue